import React from 'react';

export type SelectOption = { label: string; value: string; disabled?: boolean };

// Polaris React's Select took an `options` array; s-select takes s-option children.
// Avoid an empty `value`: s-option then uses the label as the option's value.
export const renderOptions = (options: SelectOption[]) =>
  options.map(({ label, value, disabled }) => (
    <s-option key={value} value={value} disabled={disabled}>
      {label}
    </s-option>
  ));
